import React, { useState, useEffect } from 'react';
import { FaFile } from "react-icons/fa";
import { programmeService } from '../services/programmeService';
import { supabase } from '../supabaseClient';
import './PDFButtons.css';

function PDFButtons() {
  const [programmeData, setProgrammeData] = useState({
    pdfUrl: '',
    buttonText: 'Voir le Programme',
    isVisible: true,
    flashInfoPdfUrl: '',
    flashInfoButtonText: 'Flash Info',
    flashInfoIsVisible: true,
    pdf2Url: '',
    pdf2ButtonText: 'Document 2',
    pdf2IsVisible: true,
    pdf3Url: '',
    pdf3ButtonText: 'Document 3',
    pdf3IsVisible: true
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProgrammeData();
  }, []);

  const loadProgrammeData = async () => {
    try {
      setLoading(true);
      // Get active edition first
      const { data: activeEdition } = await supabase
        .from('editions')
        .select('year, id')
        .eq('is_active', true)
        .single();
      
      let editionYear = '2025'; // Default fallback
      
      if (activeEdition) {
        editionYear = activeEdition.year;
      }

      console.log('PDFButtons: Loading data for edition:', editionYear);
      const data = await programmeService.getProgrammeData(editionYear);
      console.log('PDFButtons: Loaded data:', data);
      
      if (data) {
        setProgrammeData(data);
        console.log('PDFButtons: Final data set:', data);
      }
    } catch (error) {
      console.error('Error loading programme data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleProgrammeClick = () => {
    if (programmeData.pdfUrl) {
      window.open(programmeData.pdfUrl, '_blank');
    }
  };

  const handleFlashInfoClick = () => {
    if (programmeData.flashInfoPdfUrl) {
      window.open(programmeData.flashInfoPdfUrl, '_blank');
    }
  };

  const handlePDF2Click = () => {
    if (programmeData.pdf2Url) {
      window.open(programmeData.pdf2Url, '_blank');
    }
  };

  const handlePDF3Click = () => {
    if (programmeData.pdf3Url) {
      window.open(programmeData.pdf3Url, '_blank');
    }
  };

  if (loading) {
    return null;
  }

  // Check which buttons should be visible - only PDF2 and PDF3
  const shouldShowPDF2 = programmeData.pdf2IsVisible && programmeData.pdf2Url;
  const shouldShowPDF3 = programmeData.pdf3IsVisible && programmeData.pdf3Url;

  console.log('PDFButtons render check:', {
    pdf2IsVisible: programmeData.pdf2IsVisible,
    pdf2Url: programmeData.pdf2Url,
    shouldShowPDF2,
    pdf3IsVisible: programmeData.pdf3IsVisible,
    pdf3Url: programmeData.pdf3Url,
    shouldShowPDF3
  });

  if (!shouldShowPDF2 && !shouldShowPDF3) {
    console.log('PDFButtons: No buttons to show');
    return null;
  }

  return (
    <div className="pdf-buttons-container">
      <div className="pdf-buttons">
        {shouldShowPDF2 && (
          <button 
            className="pdf-button pdf2-button"
            onClick={handlePDF2Click}
          >
            <FaFile />
            <span>{programmeData.pdf2ButtonText}</span>
          </button>
        )}

        {shouldShowPDF3 && (
          <button 
            className="pdf-button pdf3-button"
            onClick={handlePDF3Click}
          >
            <FaFile />
            <span>{programmeData.pdf3ButtonText}</span>
          </button>
        )}
      </div>
    </div>
  );
}

export default PDFButtons;
